import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

import { useSocialInboxDataSource } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxDataSource';
import { useSWRSocket, WEBSOCKET_EVENTS } from '@/utils/hooks/swr/useSWRSocket';

import { DMConversationRefreshEvent } from '@/components/pages/conversations/SocialInbox/types';

import { MANAGE_DM_TRACKER } from '@/lib/routes/privateRoutes';

import Icon from '@/components/base/Icon';
import Loader from '@/components/base/Loader';

export const RefreshButton = () => {
    const [isRefreshing, setIsRefreshing] = useState(false);
    const { isLoading, isLoadingMore, triggerFetchJob, refreshMessages } =
        useSocialInboxDataSource();
    const path = usePathname();
    const { data: eventData } = useSWRSocket<DMConversationRefreshEvent>();

    const isDirectMessage = path === MANAGE_DM_TRACKER;

    const handleRefresh = () => {
        if (isDirectMessage) {            
            setIsRefreshing(true);

            triggerFetchJob();
            return;
        }

        refreshMessages();
    };

    useEffect(() => {
        if ([WEBSOCKET_EVENTS.INSTAGRAM_CONVERSATION_REFRESH, WEBSOCKET_EVENTS.FACEBOOK_CONVERSATION_REFRESH].includes(eventData?.event)) {
            setIsRefreshing(false);
        }
    }, [eventData]);

    return (isLoading && !isLoadingMore) || isRefreshing ? (
        <Loader className="size-4 text-icoBlack dark:text-white" />
    ) : (
        <Icon
            icon="refresh"
            className="text-12 cursor-pointer text-icoBlack dark:text-white"
            onClick={handleRefresh}
        />
    );
};
